<template>
    <div>
        <a-table :columns="columns" :data-source="tablePurchaseOrders" :loading="tableLoading" :pagination="pagination"
            class="tableStyle" :scroll="{ x: 1500, y: 600 }">

            <!-- <template slot="thumb" slot-scope="">
                <img src='../../assets/img/biothrax_bottom_260_x_300_removebg_preview.png'/>
            </template> -->
            <template slot="action" slot-scope="data">
                <a-dropdown>
                    <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                        <a-icon style="font-size:25px;" type="ellipsis" />
                    </a>
                    <a-menu slot="overlay">
                        <a-menu-item>
                            <a @click="showMoreDetails(data)">View Details?</a>
                        </a-menu-item>
                        <a-menu-item v-if="showCancelActions(data)">
                            <a @click="cancelPurchaseOrder(data)">Cancel Purchase Order?</a>
                        </a-menu-item>
                        <a-menu-item v-if="showReceiveActions(data)">
                            <a @click="showReceiveModal(data)">Receive Purchase Order?</a>
                        </a-menu-item>
                        <a-menu-item v-if="showCompletedActions(data)">
                            <a @click="completedOrder(data)">Complete Purchase Order?</a>
                        </a-menu-item>
                        <a-menu-item v-if="showMarkAsSendActions(data)">
                            <a @click="markAsSend(data)">Mark as sent?</a>
                        </a-menu-item>
                        <a-menu-item v-if="showPreview(data)">
                            <a @click="showPurchaseOrderPreview(data)">Preview?</a>
                        </a-menu-item>
                        <a-menu-item v-if="showDownload(data)">
                            <a @click="showPurchaseOrderDownload(data)">Download?</a>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown>
            </template>
            <template slot="statusLabel" slot-scope='data'>
                <status-component :status="data"></status-component>
            </template>
        </a-table>

        <!-- Receive Purchase Order Model -->
        <a-modal class="modalStyle" :visible="receiveOrderVisible" width="1000px" :footer="null"
            @cancel="handleReceiveOrderCancel">
            <a-spin :spinning="loading">
                <h3
                    style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;padding-bottom:30px">
                    Receive Purchase Orders</h3>
                <receive-orders-form :data="data" @inventoryRequest="handleAddInventoryTransfer"></receive-orders-form>
            </a-spin>
        </a-modal>

        <purchase-order ref="purchaseOrderRef"></purchase-order>
        <download-purchaseOrder ref="purchaseOrderDownloadRef"></download-purchaseOrder>
    </div>

</template>
<script>

import moment from 'moment';
// import _ from 'lodash';
// import XLSX from "xlsx";
import { NotificationMixins }  from '@/mixins/NotificationMixins'
import { mapActions } from 'vuex';
import ReceiveOrdersForm from '../modals/ReceiveOrdersForm.vue'
import PurchaseOrder from '../common/PurchaseOrder.vue'
import DownloadPurchaseOrder from '../common/DownloadPurchaseOrder.vue'

const columns = [
{
    title: "Purchase Order #",
    width: 150,
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: 'Supplier Name',
    dataIndex: 'supplierName',
    width: 150,
    },
    {
        title: 'Purchase Date',
        dataIndex: 'purchaseDate',
        width: 150,
    },
    {
        title: 'Warehouse',
        dataIndex: 'wareHouse',
        width: 150,
    },
  {
    title: 'Total Amount',
    dataIndex: 'totalAmount',
    width: 150,
    },

    {
        title: 'Shipping Terms',
        dataIndex: 'terms',
        width: 150,
    },
  {
    title: 'Created At',
    dataIndex: 'createdAt',
    width: 150,
  },
 
  {
    title: 'Status',
    dataIndex: 'statusLabel',
    width: 150,
    scopedSlots: { customRender: 'statusLabel' }
  },
 
  {
    title: 'Action',
    dataIndex: 'action',
    width: 150,
    scopedSlots: { customRender: 'action' }
  }
];

const tableData = []


    import StatusComponent from '../../shared-components/StatusComponent.vue'
    export default {
        name:"AllPurchaseOrders",
        props:['purchaseOrdersData'],
        mixins: [ NotificationMixins ],
        components: {
            StatusComponent,
            ReceiveOrdersForm,
            PurchaseOrder,
            DownloadPurchaseOrder
        },
        data(){
            return{
                tablePurchaseOrders: this.purchaseOrdersData,
                tableLoading: false,
                receiveOrderVisible: false,
                loading: false,
                columns,
                data: {},
                tableData,
                pagination: {
                    pageSize:20
                },
                invoiceData: {
                    sellerName: "",
                    terms: "",
                    sellerAddress:"",
                    sellerCity: "",
                    sellerCountry: "",
                    retailerName: '',
                    retailerAddress: '',
                    retailerCity: '',
                    retailerCountry: '',
                    discount:'',
                    subTotal: '',
                    cowtribeDate:'',
                    id: '',
                    shippingMethodLabel: '',
                    deliveryDate: '',
                    total: '',
                    products: [],
                },
            }
        },
        methods:{
            ...mapActions(['setPreviewInfo','addStockToWarehouse']),
            handleReceiveOrderCancel(){
                this.receiveOrderVisible = false
            },
            cancelPurchaseOrder(data){
                const request = {
                    status: 4,
                    id: data.id
                }
                this.$emit('orderStatus',request) 
            },
            completedOrder(data){
                const request = {
                    status: 3,
                    id: data.id
                }
                this.$emit('orderStatus',request) 
            },
            
            markAsSend(data){
                const request = {
                    status: 1,
                    id: data.id
                }
                this.$emit('orderStatus',request) 
            },
            showReceiveModal(data){
                this.data = data
                this.receiveOrderVisible = true
            },
            showMoreDetails(data){
                // console.log("data | ", data)
                const purchaseOrders = data.purchaseOrderLines.map(order => ({
                    key: order.id,
                    id: order.id,
                    productId: order.productId,
                    name: order.productName,
                    category: order.categoryName ? order.categoryName : "",
                    quantity: order.quantity.toString(),
                    unitPrice: order.price.toString(),
                    lineTotal: (parseInt(order.quantity) * parseFloat(order.price)).toFixed(2)
                }))
                let previewData = { 
                    discount: data.discount,
                    purchaseOrderId: data.id,
                    deliveryDate: moment(data.deliveryDate).format(),
                    supplierName: data.supplierName,
                    supplierId: data.supplierId,
                    supplierAddress: data.supplierAddress,
                    supplierCity: '',
                    supplierCountry: '',
                    destionation: '',
                    sellerAddress: data.sellerAddress,
                    shipCity: '',
                    shipCountry:'',
                    shippingMethodLabel: data.shippingMethodLabel,
                    shippingMethod: data.shippingMethod,
                    shippinTerm: data.terms,
                    tableData: purchaseOrders,
                    action: "edit",
                    statusLabel: data.statusLabel,
                    deleiveries: data.inventoryDeliveries
                }
                // console.log("previewData | ", previewData)
                this.setPreviewInfo(JSON.stringify(previewData)); 
                this.$router.push({
                    name: 'purchase-order-invoice'
                    }).catch(()=>{})
            },
            showCancelActions(data){
                const allowedStatus = ['Draft', 'Pending']
                const result = allowedStatus.includes(data.statusLabel) ? true : false
                return result
            },
            showReceiveActions(data){
                const allowedStatus = ['Receiving', 'Pending']
                const result = allowedStatus.includes(data.statusLabel) ? true : false
                return result
            },
            showCompletedActions(data){
                const allowedStatus = ['Receiving']
                const result = allowedStatus.includes(data.statusLabel) ? true : false
                return result
            },
            showMarkAsSendActions(data){
                const allowedStatus = ['Draft']
                const result = allowedStatus.includes(data.statusLabel) ? true : false
                return result
            },
            showPreview(data){
                const allowedStatus = ['Draft','Pending','Receiving','Completed','Cancelled']
                const result = allowedStatus.includes(data.statusLabel) ? true : false
                return result
            },
            showDownload(data){
                const allowedStatus = ['Draft','Pending','Receiving','Completed','Cancelled']
                const result = allowedStatus.includes(data.statusLabel) ? true : false
                return result
            },
            showPurchaseOrderPreview(data){
                const sellerAddressObject = JSON.parse(data.sellerAddress)
                const supplierAddressObject = JSON.parse(data.supplierAddress)

                this.invoiceData.sellerName = data.supplierName//sellerAddressObject.destionationName ? sellerAddressObject.destionationName : ''
                this.invoiceData.sellerAddress = supplierAddressObject.supplierAddress === "N/A" ? '' : supplierAddressObject.supplierAddress//sellerAddressObject.sellerAddress === "N/A" ? '' : sellerAddressObject.sellerAddress
                this.invoiceData.sellerCity = supplierAddressObject.supplierCity  === "N/A" ? '' : supplierAddressObject.supplierCity//sellerAddressObject.shipCity === "N/A" ? '' : sellerAddressObject.shipCity
                this.invoiceData.sellerCountry = supplierAddressObject.supplierCountry  === "N/A" ? '' : supplierAddressObject.supplierCountry//sellerAddressObject.shipCountry === "N/A" ? '' : sellerAddressObject.shipCountry

                this.invoiceData.retailerName = sellerAddressObject.destionationName ? sellerAddressObject.destionationName : ''//data.supplierName
                this.invoiceData.retailerAddress = sellerAddressObject.sellerAddress === "N/A" ? '' : sellerAddressObject.sellerAddress//supplierAddressObject.supplierAddress === "N/A" ? '' : supplierAddressObject.supplierAddress
                this.invoiceData.retailerCity = sellerAddressObject.shipCity === "N/A" ? '' : sellerAddressObject.shipCity//supplierAddressObject.supplierCity  === "N/A" ? '' : supplierAddressObject.supplierCity
                this.invoiceData.retailerCountry = sellerAddressObject.shipCountry === "N/A" ? '' : sellerAddressObject.shipCountry//supplierAddressObject.supplierCountry  === "N/A" ? '' : supplierAddressObject.supplierCountry
               
                this.invoiceData.terms = data.terms
                this.invoiceData.discount = data.discount
                this.invoiceData.subTotal = data.subTotal
                
              
                this.invoiceData.deliveryDate = data.deliveryDate ?  moment(data.deliveryDate).format("DD-MM-YYYY") : ''
                this.invoiceData.cowtribeDate = moment(data.createdAt).format("DD-MM-YYYY")
                this.invoiceData.id = data.id ? data.id : ''
                this.invoiceData.shippingMethodLabel = data.shippingMethodLabel 
                this.invoiceData.products = data.purchaseOrderLines.map(product => ({
                    id: product.id,
                    productName: product.productName,
                    quantity: product.quantity,
                    unitPrice: product.price,
                    lineTotal: parseInt(product.quantity) * parseFloat(product.price)
                }))
                this.invoiceData.subTotal = this.getProductsTotalAmount(this.invoiceData.products)
                this.invoiceData.total = data.totalOrderValue
            
                this.$refs.purchaseOrderRef.showInvoiceForm(this.invoiceData);
            },
            showPurchaseOrderDownload(data){
                const sellerAddressObject = JSON.parse(data.sellerAddress)
                const supplierAddressObject = JSON.parse(data.supplierAddress)

                this.invoiceData.sellerName = data.supplierName//sellerAddressObject.destionationName ? sellerAddressObject.destionationName : ''
                this.invoiceData.sellerAddress = supplierAddressObject.supplierAddress === "N/A" ? '' : supplierAddressObject.supplierAddress//sellerAddressObject.sellerAddress === "N/A" ? '' : sellerAddressObject.sellerAddress
                this.invoiceData.sellerCity = supplierAddressObject.supplierCity  === "N/A" ? '' : supplierAddressObject.supplierCity//sellerAddressObject.shipCity === "N/A" ? '' : sellerAddressObject.shipCity
                this.invoiceData.sellerCountry = supplierAddressObject.supplierCountry  === "N/A" ? '' : supplierAddressObject.supplierCountry//sellerAddressObject.shipCountry === "N/A" ? '' : sellerAddressObject.shipCountry

                this.invoiceData.retailerName = sellerAddressObject.destionationName ? sellerAddressObject.destionationName : ''//data.supplierName
                this.invoiceData.retailerAddress = sellerAddressObject.sellerAddress === "N/A" ? '' : sellerAddressObject.sellerAddress//supplierAddressObject.supplierAddress === "N/A" ? '' : supplierAddressObject.supplierAddress
                this.invoiceData.retailerCity = sellerAddressObject.shipCity === "N/A" ? '' : sellerAddressObject.shipCity//supplierAddressObject.supplierCity  === "N/A" ? '' : supplierAddressObject.supplierCity
                this.invoiceData.retailerCountry = sellerAddressObject.shipCountry === "N/A" ? '' : sellerAddressObject.shipCountry//supplierAddressObject.supplierCountry  === "N/A" ? '' : supplierAddressObject.supplierCountry
               
                this.invoiceData.terms = data.terms
                this.invoiceData.discount = data.discount
                this.invoiceData.subTotal = data.subTotal
                
              
                this.invoiceData.deliveryDate = data.deliveryDate ?  moment(data.deliveryDate).format("DD-MM-YYYY") : ''
                this.invoiceData.cowtribeDate = moment(data.createdAt).format("DD-MM-YYYY")
                this.invoiceData.id = data.id ? data.id : ''
                this.invoiceData.shippingMethodLabel = data.shippingMethodLabel 
                this.invoiceData.products = data.purchaseOrderLines.map(product => ({
                    id: product.id,
                    productName: product.productName,
                    quantity: product.quantity,
                    unitPrice: product.price,
                    lineTotal: parseInt(product.quantity) * parseFloat(product.price)
                }))
                this.invoiceData.subTotal = this.getProductsTotalAmount(this.invoiceData.products)
                this.invoiceData.total = data.totalOrderValue
                this.$refs.purchaseOrderDownloadRef.downloadPurchaseOrder(this.invoiceData);
            },

            getProductsTotalAmount(products){
                // console.log("in tableData |", this.tableData)
                const itemAmount = products.map(item => {
                    if(item.lineTotal){
                        return parseFloat(item.lineTotal) 
                    }else{
                        return 0.00
                    }
                })
                // console.log("in each itemAmount |", itemAmount)
                const totalAmt = itemAmount.reduce((acc, item) => acc + item, 0);
                // console.log("in computed totalAmt |", totalAmt)
                return parseFloat(totalAmt)

            },
            async handleAddInventoryTransfer(data){
                this.loading = true;
                const response = await this.addStockToWarehouse(data);
                this.loading = false;
                if (response.status === 200) {
                    this.receiveOrderVisible = false
                    this.showSuccessAlert("Purchase Order Received Successfully");
                    this.$emit('orderData', true)  
                } else {
                    // // console.log("Error | ", response);
                    this.showErrorAlert(response.data.messages);
                }  
                 
            },
        },
        computed:{
            
        },
        watch: { 
            purchaseOrdersData:{
                immediate: true, 
                handler (newValues) {
                    this.tablePurchaseOrders = newValues
                }
                
            }    
        }
    }
</script>

<style  scoped>

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}
.customerTable >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.customerTable >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.customerTable >>> .ant-pagination-item-active a {
    color: #fff;
}
.customerTable >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle >>> .ant-pagination-item-active a {
    color: #fff;
}
.tableStyle >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}

</style>